goog.provide('el8.uiwidget.multifieldListeditor');

goog.require('el8.template.uiwidget.multifieldListeditor');


/**
 * This widget manages something like a Listeditor, but with multiple input fields
 * on each line. It is useful for creating a list of objects (blood pressures,
 * billing entries, etc.) that are defined by multiple properties (systolic/diastolic,
 * CPT/DXs/Modifiers, etc.).
 *
 * It is still backed by a single Form object. The convention is that the 1st field 'name'
 * has the fieldname 'name_0'. The abstraction is still kind of leaky, so outsiders
 * will have to enforce that convention too (in the template and field construction)
 *
 * See GenericBillDialog.js for an example user.
 */
el8.uiwidget.multifieldListeditor = function(opts) {
    this._opts = opts || {};
};

el8.uiwidget.multifieldListeditor.prototype.init = function() {
    // the selector (usually an <ol>) this list will append to
    this.$listContainer = jQuery.isFunction(this._opts.listContainer) ? this._opts.listContainer() : this._opts.listContainer;

     // the template to represent one new row; takes an index
    this._templateFn = this._opts.templateFn;
    this._templateArgs = this._opts.templateArgs || {};
     // a function which takes (index) and returns a field dict to add to the Form
    this._fieldSpecFn = this._opts.fieldSpecFn;
     // a function which runs after a new entry has been added to the DOM,
     // to run any custom initialization that doesn't fit in the Form spec
    this._customInitEntry = this._opts.customInitEntryFn;
     // a function which takes (index) and returns a dict of the values at that entry;
     // this is necessary because things like listeditors do not get auto-extracted by form.getMapped
    this._getEntryMapFn = this._opts.getEntryMapFn;

     // the Form object this multifield list belongs to / will add to
    this._form = this._opts.form;

    if (this._opts.sortable) {
        var _sortUpdateFn = this._opts.sortUpdateFn;
        this.$listContainer.sortable({
            handle: '.mle-sort',
            items: 'li.multifield-entry',
            cursor: 'move',
            tolerance: 'pointer', // greater sensitivity works better for large elements
            forcePlaceholderSize: true, // show a gray box (otherwise hard to see drop zone)
            placeholder: 'el8MultifieldEntryPlaceholder',
            update: function(event, ui) {
                if (_sortUpdateFn) { _sortUpdateFn(); }
            }
        });
    }

    // add an initial row
    this.addNewEntry();

    return this;
};

el8.uiwidget.multifieldListeditor.prototype.addNewEntry = function(noFocus) {
    var index = this.getMaxIndex() + 1;
    var entryContents = this._templateFn($.extend({index: index}, this._templateArgs));
    var $entry = $(el8.template.uiwidget.multifieldListeditor.entry({index: index}));
    $entry.html(entryContents);
    this.$listContainer.append($entry);
    var newFields = this._fieldSpecFn(index);
    this._form.addFields(newFields);

    if (this._customInitEntry) { this._customInitEntry($entry, index); }

    // noFocus should generally be true if we're adding a bunch of entries while populating a form
    if (!noFocus) { this._form.focusField(newFields[0].name); }

    return index;
};

// This will replace an existing entry with an empty entry
el8.uiwidget.multifieldListeditor.prototype.refreshEntry = function(index) {
    var entryContents = this._templateFn($.extend({index: index}, this._templateArgs));
    var $entry = this.getDomEntry(index);
    $entry.html(entryContents);

    // replace the fields so they're properly initialized
    var deadFieldNames = _.pluck(this._fieldSpecFn(index), 'name');
    this._form.removeFields(deadFieldNames);
    var newFields = this._fieldSpecFn(index);
    this._form.addFields(newFields);

    return index;
};

el8.uiwidget.multifieldListeditor.prototype.removeEntry = function(index, noFocus) {
    var $entry = this.$listContainer.find('.multifield-entry[data-index="'+index+'"]');
    $entry.remove();

    var deadFieldNames = _.pluck(this._fieldSpecFn(index), 'name');
    this._form.removeFields(deadFieldNames);

    if (!this.$listContainer.find('.multifield-entry').length) {
        this.addNewEntry(noFocus);
    }
};

el8.uiwidget.multifieldListeditor.prototype.getLastIndex = function() {
    if (this.$listContainer.find('.multifield-entry').length) {
        return this.$listContainer.find('.multifield-entry').last().data('index');
    } else {
        return -1;
    }
};

el8.uiwidget.multifieldListeditor.prototype.getMaxIndex = function() {
    var allIndexes = this.getAllIndexes();
    return (allIndexes.length > 0) ? _.max(allIndexes) : -1;
};


// Note that this isn't the same as iterating from 0 to getNumEntries,
// because when we delete entries, we don't change their indexes,
// so we might have three entries with indexes 0, 2, 3
el8.uiwidget.multifieldListeditor.prototype.getAllIndexes = function() {
    return $('.multifield-entry', this.$listContainer).map(function() {
        return $(this).data('index');
    }).toArray();
};

el8.uiwidget.multifieldListeditor.prototype.getAllEntries = function() {
    var that = this;
    var results = [];
    $('.multifield-entry', this.$listContainer).each(function() {
        var index = $(this).data('index');
        results.push(that._getEntryMapFn(that, index));
    });
    return results;
};
el8.uiwidget.multifieldListeditor.prototype.getEntry = function(index) {
    return this._getEntryMapFn(this, index);
};
el8.uiwidget.multifieldListeditor.prototype.getNumEntries = function() {
    return $('.multifield-entry', this.$listContainer).length;
};


el8.uiwidget.multifieldListeditor.prototype.getDomEntries = function() {
    return $('.multifield-entry', this.$listContainer);
};
el8.uiwidget.multifieldListeditor.prototype.getDomEntry = function(index) {
    return $('.multifield-entry[data-index="'+index+'"]', this.$listContainer);
};

el8.uiwidget.multifieldListeditor.prototype.setVal = function(fieldName, index, newVal, noNotify) {
    this._form.setVal(fieldName+'_'+index, newVal, noNotify);
};
el8.uiwidget.multifieldListeditor.prototype.getVal = function(fieldName, index) {
    return this._form.getVal(fieldName+'_'+index);
};
el8.uiwidget.multifieldListeditor.prototype.focusField = function(fieldName, index) {
    return this._form.focusField(fieldName+'_'+index);
};
el8.uiwidget.multifieldListeditor.prototype.getListeditor = function(fieldName, index) {
    return this._form.getListeditor(fieldName+'_'+index);
};
el8.uiwidget.multifieldListeditor.prototype.getIcd10Listeditor = function(fieldName, index) {
    return this._form.getIcd10Listeditor(fieldName+'_'+index);
};
el8.uiwidget.multifieldListeditor.prototype.getMindreader = function(fieldName, index) {
    return this._form.getMindreader(fieldName+'_'+index);
};
el8.uiwidget.multifieldListeditor.prototype.hideAllMindreaders = function() {
    var mindreaders = this._form._mindreaders;
    for (var mr in mindreaders) {
        if (mindreaders.hasOwnProperty(mr)) {
            mindreaders[mr].hide();
        }
    }
};
el8.uiwidget.multifieldListeditor.prototype.populate = function(spec, index, noNotify) {
    var modified = {};
    for (var key in spec) {
        if (spec.hasOwnProperty(key)) {
            modified[key+'_'+index] = spec[key];
        }
    }
    this._form.populate(modified, noNotify);
};

el8.uiwidget.multifieldListeditor.prototype.reset = function() {
    var that = this;
    $('.multifield-entry', this.$listContainer).each(function() {
        var index = $(this).data('index');
        // don't focus on the new entry we created when resetting the form,
        // in case focusing pops up a mindreader
        that.removeEntry(index, true);
    });
};


/* These are for replacing all existing fields, when populating a newly initialized list.
 *
 * "dicts" is a list of dicts that would be handed to form.populate. This method takes
 * care of adding an index to the names.
 *
 * Same deal with entriesLists - it's a list of lists that would be handed to listeditor.addEntries,
 * and the method will take care of adding an index to the names.
 */
el8.uiwidget.multifieldListeditor.prototype.populateEntries = function(dicts) {
    var that = this;
    var $entries = $('.multifield-entry', this.$listContainer);
    var numMissingEntries = dicts.length - $entries.length;
    while (numMissingEntries > 0) {
        this.addNewEntry(true);
        numMissingEntries--;
    }

    dicts.forEach(function(dict, index) {
        var newDict = {};
        for (var key in dict) {
            if (dict.hasOwnProperty(key)) {
                newDict[key+'_'+index] = dict[key];
            }
        }
        that._form.populate(newDict);
    });
};
el8.uiwidget.multifieldListeditor.prototype.populateListeditorEntries = function(leName, entriesLists) {
    var that = this;
    var $entries = $('.multifield-entry', this.$listContainer);
    var numMissingEntries = entriesLists.length - $entries.length;
    while (numMissingEntries > 0) {
        this.addNewEntry(true);
        numMissingEntries--;
    }

    entriesLists.forEach(function(list, index) {
        that._form.getListeditor(leName+'_'+index).addEntries(list);
    });
};

// Used for Visit Note Template to serialize editor data into JSON format
// so that it can be saved in the DB
//
// Will return null if there are no entries in the listeditor
el8.uiwidget.multifieldListeditor.prototype.getJsonData = function() {
    var entries = this.getAllEntries();

    if (entries && entries.length) {
        entries = _.filter(entries, function(entry) {
            // skip completely empty entries
            return (entry.cpt || entry.dxs.length);
        });
        return entries;
    } else {
        return null;
    }
};